var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "product-tile",
      class: _vm.tileClass,
      style: { backgroundColor: _vm.tileColor }
    },
    [
      _c(
        _vm.noLink ? "div" : "a",
        {
          tag: "a",
          staticClass: "link--unstyled",
          attrs: { href: _vm.product.url }
        },
        [
          _c("div", { staticClass: "product-tile__media" }, [
            _vm.image
              ? _c("div", { staticClass: "product-tile__media-wrapper" }, [
                  _c("img", {
                    staticClass: "product-tile__image",
                    attrs: {
                      src: _vm.currentImage,
                      alt: _vm.image.alt,
                      draggable: false
                    }
                  }),
                  _vm.productBadge
                    ? _c("div", { staticClass: "product-tile__badge" }, [
                        _c(
                          "div",
                          { staticClass: "product-tile__badge__text" },
                          [_vm._v(_vm._s(_vm.productBadge))]
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ]),
          _c("div", { staticClass: "product-tile__content" }, [
            _c("div", { staticClass: "product-tile__details" }, [
              _c("h3", { staticClass: "product-tile__title" }, [
                _vm._v(_vm._s(_vm.product.title))
              ]),
              _vm.subHeading
                ? _c("div", { staticClass: "product-tile__tag" }, [
                    _vm._v(_vm._s(_vm.subHeading))
                  ])
                : _vm._e()
            ]),
            _c("div", { staticClass: "product-tile__pricing" }, [
              _vm.isOnSale
                ? _c("p", { staticClass: "product-tile__price" }, [
                    _vm._v(
                      _vm._s(_vm._f("moneyWithoutDecimals")(_vm.product.price))
                    ),
                    _c(
                      "s",
                      {
                        staticClass:
                          "product-tile__price product-tile__price--original"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("moneyWithoutDecimals")(_vm.comparePrice)
                          )
                        )
                      ]
                    )
                  ])
                : _c("p", { staticClass: "product-tile__price" }, [
                    _vm._v(
                      _vm._s(_vm._f("moneyWithoutDecimals")(_vm.product.price))
                    )
                  ])
            ])
          ])
        ]
      ),
      _c(
        "form",
        {
          staticClass: "product-tile__form",
          attrs: { novalidate: "" },
          on: {
            submit: function($event) {
              $event.preventDefault()
              return _vm.addToCart.apply(null, arguments)
            }
          }
        },
        [
          _c(
            "base-button",
            {
              staticClass: "product-tile__form-submit",
              attrs: { disabled: _vm.isDisabled, loading: _vm.adding }
            },
            [_vm._v(_vm._s(_vm.addToCartText))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }